import React, {useEffect, useState} from "react";
import Button from "../baseComponents/gui/button/Button";
import buttonStyles from "../baseComponents/gui/button/Button.module.scss";
import Countdown from "react-countdown";
import {rendererTime} from "../../utils/data/rendererTime";
import classNames from "classnames";
import {defaultPrize} from "../../constants/copyright";
import styles from "./PrizeTimer.module.scss";

const PrizeTimer = React.forwardRef(
  function PrizeTimer({info, className}, ref) {
    const [render, setRender] = useState(false);

    const {lottery, buttonLink, image, show_jackpot, show_timer, show_button} = info
    const {date, superPrize} = lottery?.draw ?? {};


    const checkButtonLink = () => {
      const pattern = /^https?:\/\//
      return buttonLink && pattern.test(buttonLink)
    }

    useEffect(() => {
      setRender(true)
    }, []);

    return (
      <section className={classNames(styles.prizeTimer, className, {
        [styles.prizeTimer_imageOnly]: image && !show_timer && !show_jackpot && !show_button
      })} ref={ref}>
        <a target={"_blank"} href={checkButtonLink() && buttonLink} className={styles.prizeTimer__content}>
          <div className={styles.prizeTimer__contentBg}>
            {image && <img src={image} alt="bg" loading="lazy" width={1312} height={240}/>}
          </div>

          <div className={styles.prizeTimer__block}>
            {show_timer && <div className={styles.prizeTimer__timer}>
              {render && <Countdown date={new Date(date * 1000)}
                                    renderer={rendererTime}
              />}
            </div>}
            {show_jackpot && <div
              className={styles.prizeTimer__title}>{`Джекпот ${new Intl.NumberFormat('ru-RU').format(superPrize)}₽`}</div>}
            {show_button &&
            <Button className={classNames(styles.prizeTimer__button,
              buttonStyles.button_black,
              buttonStyles.button_big,
            )}
                    {...defaultPrize?.button}
                    href={buttonLink}>
              <div className="button__effect"/>
            </Button>}
          </div>
        </a>
      </section>
    );
  });
export default PrizeTimer;
PrizeTimer.propTypes = {};

